import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { MobileVersions } from '@wilson/api';

@Injectable({
  providedIn: 'root',
})
export class VersioningService {
  private httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  getMobileVersions() {
    return this.httpClient.get<MobileVersions>(
      `${this.config.host}/mobile/versions`,
    );
  }
}
